import { Component, TemplateRef } from '@angular/core';
import { LoaderComponent } from '../../layout/loader/loader.component';
import { CommonModule } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { ApiService } from '../../../services/api.service';
import { SchoolInformationFormComponent } from '../school-information-form/school-information-form.component';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { licenseListComponent } from '../../license/license-list/license-list.component';
import { licenseFormComponent } from '../../license/license-form/license-form.component';

import { TabGroupComponent } from '../../tab-group/tab-group.component';
import { TabComponent } from '../../tab/tab.component';
import { FormsModule } from '@angular/forms';

import { TableGuruComponent } from '../../table-guru/table-guru.component';
import { OrderCreateFormComponent } from '../../order/order-create-form/order-create-form.component';
import { TeacherInformationFormComponent } from '../../teacher-information-form/teacher-information-form.component';
import { ManagerInformationFormComponent } from '../../manager-information-form/manager-information-form.component';
import { ConfirmDeleteComponent } from '../../confirm-delete/confirm-delete.component';

import { PageHeaderComponent } from '../../page-header/page-header.component';
import { CustomCheckboxComponent } from '../../custom-checkbox/custom-checkbox.component';


@Component({
  selector: 'app-school-details',
  standalone: true,
  imports: [
    CommonModule,
    SchoolInformationFormComponent,
    LoaderComponent,
    licenseListComponent,
    TabGroupComponent,
    TabComponent,
    FormsModule,
    TableGuruComponent,
    PageHeaderComponent,
    CustomCheckboxComponent
  ],
  templateUrl: './school-details.component.html',
  styleUrl: './school-details.component.scss'
})
export class SchoolDetailsComponent {
  loading: boolean = false;
  item: any | null = null;
  courses: any = [];

  licenses: any | null;

  addFormReference = OrderCreateFormComponent;

  periods: any | [];
  selectedPeriod: any = null;

  groupedLicenses: any = {};

  itemId: any | null = null;

  reloadItems: boolean = false;

  courseImages: any = {};

  regions = [
    'noord',
    'midden',
    'zuid'
  ];

  deleteTerms = [
    6, 9, 12, 24
  ];
  pages = [];

  constructor(
    private router: Router,
    private modalService: NgbModal,
    private activatedRoute: ActivatedRoute,
    private apiService: ApiService
  ) {
    this.loading = true;
    this.getItem();
    this.getPeriods();
  }

  editSchool() {
    let self = this;
    const modalRef = this.modalService.open(SchoolInformationFormComponent, { size: 'lg' });
    modalRef.componentInstance.modalStyle = true;
    modalRef.componentInstance.organisationId = this.item['id'];
    modalRef.componentInstance.modalInstance = modalRef;

    modalRef.componentInstance.item = this.item;

    modalRef.result.then((result) => {
      self.getItem();
      self.setReloadItems();
    });
  }

  confirmDelete() {
    const self = this;

    const deleteModal = this.modalService.open(ConfirmDeleteComponent);
    deleteModal.componentInstance.message = 'Weet je zeker dat je deze school wilt verwijderen?';
    deleteModal.result.then((result) => {
      if (result) {
        this.apiService
          .delete(`/office/organisations/${self.item.id}`)
          .then(() => {
            self.router.navigate(['/school/list']);
          })
      }
    });
  }

  addLicense() {
    let self = this;
    const modalRef = this.modalService.open(licenseFormComponent);
    modalRef.componentInstance.modalStyle = true;
    modalRef.componentInstance.organisationId = this.item['id'];
    modalRef.componentInstance.modalInstance = modalRef;
    modalRef.result.then((result) => {
      self.setReloadItems();
      self.getPeriods();
      self.getLicenses();
    });
  }

  addTeacher() {
    let self = this;
    const modalRef = this.modalService.open(TeacherInformationFormComponent);
    modalRef.componentInstance.modalStyle = true;
    modalRef.componentInstance.organisationId = self.item['id'];
    modalRef.componentInstance.modalInstance = modalRef;
    modalRef.result.then((result) => {
      self.setReloadItems();
    });
  }

  addManager() {
    let self = this;
    const modalRef = this.modalService.open(ManagerInformationFormComponent);
    modalRef.componentInstance.modalStyle = true;
    modalRef.componentInstance.organisationId = self.item['id'];
    modalRef.componentInstance.modalInstance = modalRef;
    modalRef.result.then((result) => {
      self.setReloadItems();
    });
  }

  setReloadItems() {
    const self = this;
    self.reloadItems = true;

    setTimeout(() => {
      self.reloadItems = false;
    }, 200);
  }

  getItem() {
    this.itemId = this.activatedRoute.snapshot.paramMap.get('id');
    let self = this;
    return this.apiService.get('/office/organisations/' + this.itemId).then(function (response: any) {
      self.item = response;

      self.item.terms_and_conditions_accepted = Number(self.item.terms_and_conditions_accepted);
      self.item.privacy_agreement_accepted = Number(self.item.privacy_agreement_accepted);
      self.item.processing_agreement_accepted = Number(self.item.processing_agreement_accepted);

      setTimeout(function () { self.loading = false; }, 200);
    }).catch(function (e) {
      self.loading = false;
    });
  }

  getCourseTitles() {
    return Object.keys(this.groupedLicenses);
  }

  saveChanges() {
    const self = this;

    self.loading = true
    return this.apiService.put('/office/organisations/' + this.itemId, this.item).then(function (response: any) {
      setTimeout(function () { self.loading = false; }, 200);
    }).catch(function (e) {
      self.loading = false;
    });
  }

  getSections(licenses: any[]) {
    const sectionsMap: any = {};

    licenses.forEach(license => {
      const sectionTitle = license.chapter.section.title;

      if (!sectionsMap[sectionTitle]) {
        sectionsMap[sectionTitle] = [];
      }

      sectionsMap[sectionTitle].push(license);
    });

    // Convert to array so *ngFor can iterate
    return Object.keys(sectionsMap).map(sectionTitle => ({
      sectionTitle,
      items: sectionsMap[sectionTitle]
    }));
  }

  openCreateOrder() {
    let self = this;
    const modalRef = this.modalService.open(this.addFormReference, { size: 'xl' });
    modalRef.componentInstance.modalStyle = true;
    modalRef.componentInstance.item = {
      period_id: this.selectedPeriod,
      organisation_id: this.item['id'],
      organisation_name: this.item['name'],
      organisation_type: this.item['type'],
      organisation_location: this.item['location'],
      organisation_address: this.item['address'],
      organisation_postal_code: this.item['postal_code'],
      organisation_country: this.item['country'],
      organisation_city: this.item['city'],
      organisation_department_number: this.item['department_number'],
      organisation_master_identifier: this.item['master_identifier'],
      name: this.item['contact_name'],
      email: this.item['contact_email'],
      invoice_name: this.item['name'],
      invoice_email: this.item['invoice_email'] ?? this.item['contact_email'],
      invoice_address: this.item['invoice_address'] ?? this.item['address'],
      invoice_postal_code: this.item['invoice_postal_code'] ?? this.item['postal_code'],
      invoice_city: this.item['invoice_city'] ?? this.item['city'],
      invoice_country: this.item['invoice_country'] ?? this.item['country'],
    };

    modalRef.result.then((result) => {
      self.reloadItems = true;

      setTimeout(() => {
        self.reloadItems = false;
      }, 200);
    });
  }

  getLicenses() {
    this.itemId = this.activatedRoute.snapshot.paramMap.get('id');
    let self = this;
    return this.apiService.get('/office/organisations/' + this.itemId + "/licenses?period_id=" + self.selectedPeriod).then(function (response: any) {
      self.licenses = response;
      self.groupLicensesByCourse();
      setTimeout(function () { self.loading = false; }, 200);
    }).catch(function (e) {
      self.loading = false;
    });
  }

  getPeriods() {
    this.itemId = this.activatedRoute.snapshot.paramMap.get('id');
    let self = this;
    return this.apiService.get('/office/organisations/' + this.itemId + "/periods").then(function (response: any) {
      self.periods = response;
      if (self.selectedPeriod == null) {
        self.selectedPeriod = response[self.periods.length - 1].id;
      }
      self.getLicenses();
      setTimeout(function () { self.loading = false; }, 200);
    }).catch(function (e) {
      self.loading = false;
    });
  }

  groupLicensesByCourse() {
    const self = this;

    this.groupedLicenses = this.licenses.reduce((groups: any, license: any) => {
      const courseTitle = license.chapter.course.title;
      if (!groups[courseTitle]) {
        groups[courseTitle] = [];
      }
      groups[courseTitle].push(license);
      if (license.chapter.course.image_url) {
        self.courseImages[courseTitle] = license.chapter.course.image_url;
      }
      return groups;
    }, {});
  }
}
